// extracted by mini-css-extract-plugin
export default {"dropdown_withCookieBanner":"languageDropdown_dropdown_withCookieBanner"};